import axios from 'axios';
import qs from 'qs';
import {Message} from 'element-ui';
import store from '@/store';

// create an axios instance
const service = axios.create({
    baseURL: '/api', // url = base url + request url
    // withCredentials: true, // send  when cross-domain requests
    timeout: 50000000 // request timeout
});

// request interceptor
service.interceptors.request.use(
    config => {
        if (config.method === 'get') {
            //config.params = {
            //  //_t: Date.now(),
            //  //...config.params,
            //};
            config.paramsSerializer = function(params) {
                return qs.stringify(params, {indices: false});
            };
        }
        config.headers.Authorization = 'Bearer ' + store.getters.token;
        config.headers.language = store.getters.language;
        config.headers.SysCode = 'AppServer';
        return config;
    },
    error => {
    // do something with request error
        console.log(error); // for debug
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

    /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
    response => {
        if (response.config && response.config.isFileDownload) {
            return response;
        }
        const res = response.data;
        // if the custom code is not 20000, it is judged as an error.
        if (!res.code) {
            Message({
                message: res.msg || 'Error',
                type: 'error',
            });
            return Promise.reject(res);
        }
        return res;
    },
    error => {
        if (error.response && error.response.status === 401) {
            if (store.getters.token) {
                store.dispatch('fedLogOut').then(() => {
                    location.reload();
                });
            }
            // toto 到登录页
        } else {
            Message({
                message: error.msg || 'Error',
                type: 'error',
            });
        }
        return Promise.reject(error);
    }
);
export default service;
